import React, { useState, useRef, useEffect } from 'react';
import cx from 'classnames';
import '../../rewards/Progress/index.js';
import '../../rewards/RewardIcon/index.js';
import '../../rewards/RewardIconWrapper/index.js';
import '../../rewards/RewardsProgressBar/index.js';
import '../../rewards/RewardStatus/index.js';
import { VipIcon } from '../../rewards/VipIcon/index.js';
import '../../rewards/InstantRakeback/index.js';
import '../../rewards/Range/index.js';
import '../../rewards/VipReload/index.js';
import '../../rewards/RewardWallet/index.js';
import '../../rewards/RewardHorizontal/index.js';
import '../../rewards/RewardHorizontalV2/index.js';
import '../../rewards/Reward/index.js';
import '../../rewards/AvailableProgress/index.js';
import '../../rewards/Benefits/index.js';
import '../../rewards/CountDownBanner/index.js';
import '../../rewards/ProgressWidget/index.js';
import '../../rewards/RewardsSliderPreview/index.js';
import '../../rewards/RewardsSlider/index.js';
import '../../rewards/VipLevelLine/index.js';
import '../../rewards/VipLevelAccordion/index.js';
import '../../rewards/VipProgress/index.js';
import '../../rewards/VipRewards/index.js';
import '../../rewards/RewardsList/index.js';
import '../../rewards/RewardTypeIcon/index.js';
import '../../rewards/RewardsDropdown/RDContent/index.js';
import '../../rewards/RewardsDropdown/RDFooter/index.js';
import '../../rewards/RewardsDropdown/RDHeader/index.js';
import '../../rewards/RewardsDropdown/RDList/index.js';
import '../../rewards/RewardsDropdown/RDRow/index.js';
import '../../rewards/RewardsDropdown/RDStatistic/index.js';
import '../../rewards/RewardsDropdown/RDWrapper/index.js';
import '../../../icons/ActivityIcon.js';
import '../../../icons/AgeIcon.js';
import '../../../icons/ArrowDownV2.js';
import '../../../icons/ArrowDownV3.js';
import '../../../icons/ArrowDown.js';
import '../../../icons/ArrowLeftBig.js';
import '../../../icons/ArrowLeft.js';
import '../../../icons/ArrowLeft2.js';
import '../../../icons/ArrowsDown.js';
import '../../../icons/ArrowsUp.js';
import '../../../icons/ArrowUpRightIcon.js';
import '../../../icons/Baccarat.js';
import '../../../icons/BlackJack.js';
import '../../../icons/BookIcon.js';
import '../../../icons/Calendar.js';
import '../../../icons/Carts.js';
import '../../../icons/ChartIcon.js';
import '../../../icons/ChainIcon.js';
import '../../../icons/CheckIcon2.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/Checks.js';
import '../../../icons/ChevronDown.js';
import '../../../icons/Clock.js';
import '../../../icons/Close.js';
import '../../../icons/CoinsIcon.js';
import '../../../icons/Coins.js';
import { CopyIconDouble } from '../../../icons/CopyIconDouble.js';
import { CopyIconFill } from '../../../icons/CopyIconFill.js';
import '../../../icons/Crown.js';
import '../../../icons/CryptoCurrency.js';
import '../../../icons/DiscordIcon.js';
import '../../../icons/DiscordIconV2.js';
import '../../../icons/Dota2.js';
import '../../../icons/Edit.js';
import '../../../icons/ExtendIcon.js';
import '../../../icons/EyeOff.js';
import '../../../icons/Eye.js';
import '../../../icons/FacebookIconV2.js';
import '../../../icons/FacebookIcon.js';
import '../../../icons/FiatCurrency.js';
import '../../../icons/FilterIcon.js';
import '../../../icons/GameIcon.js';
import '../../../icons/GameShows.js';
import '../../../icons/Game.js';
import '../../../icons/HeadPhones.js';
import '../../../icons/HomeIcon.js';
import '../../../icons/Horse.js';
import '../../../icons/InfoFill.js';
import '../../../icons/InfoIcon2.js';
import '../../../icons/InfoIcon.js';
import '../../../icons/InfoOutline.js';
import '../../../icons/LevelUp.js';
import '../../../icons/LinkIcon.js';
import '../../../icons/Link.js';
import '../../../icons/LiveCasino.js';
import '../../../icons/LiveIcons2.js';
import '../../../icons/LobbyIconV2.js';
import '../../../icons/LobbyIcon.js';
import '../../../icons/LogoSmallIcon.js';
import '../../../icons/Lock.js';
import '../../../icons/LOL.js';
import '../../../icons/MaxIcon.js';
import '../../../icons/MedalIcon.js';
import '../../../icons/MedalStarIcon.js';
import '../../../icons/MoneyBagIcon.js';
import '../../../icons/MoneyIcon.js';
import '../../../icons/MoneyRecive.js';
import '../../../icons/NewTwitterIcon.js';
import '../../../icons/OriginalsIcon.js';
import '../../../icons/Original.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PhoneChatIcon.js';
import '../../../icons/PhotoUp.js';
import '../../../icons/PlayIcon.js';
import '../../../icons/PlusIcon.js';
import '../../../icons/RainIcon.js';
import { RankIcon } from '../../../icons/RankIcon.js';
import '../../../icons/RankinIcon.js';
import '../../../icons/ReferalIcon.js';
import '../../../icons/RefreshIcon.js';
import '../../../icons/Reload.js';
import '../../../icons/Roulette.js';
import '../../../icons/Search2Icon.js';
import '../../../icons/Search.js';
import '../../../icons/SendIcon.js';
import '../../../icons/Settings2.js';
import '../../../icons/SettingsV3.js';
import '../../../icons/Settings.js';
import '../../../icons/SlotsIcon2.js';
import '../../../icons/SlotsIcon.js';
import '../../../icons/SmileIcon.js';
import '../../../icons/SocialsIcon.js';
import '../../../icons/SortIcon.js';
import '../../../icons/SponsorshipIcon.js';
import '../../../icons/StarFill.js';
import '../../../icons/StarCraft.js';
import '../../../icons/StopIcon.js';
import '../../../icons/TableGamesIcon.js';
import '../../../icons/TelegramIcon.js';
import '../../../icons/TelegramIconV2.js';
import '../../../icons/TopPicksIcon.js';
import '../../../icons/Upload.js';
import '../../../icons/UserMoney.js';
import '../../../icons/UsersIconV2.js';
import '../../../icons/UsersIcon.js';
import '../../../icons/VerifiedIcon.js';
import '../../../icons/WalletAddIcon.js';
import '../../../icons/Wallet.js';
import '../../../icons/WarningIcon.js';
import '../../../icons/DeviceDesktop.js';
import '../../../icons/DeviceTablet.js';
import '../../../icons/DevicePhone.js';
import '../../../icons/ClockOrange.js';
import '../../../icons/CalendarOrange.js';
import '../../../icons/OpenLinkIcon.js';
import '../../../icons/FavoriteFill.js';
import '../../../icons/EditorChoiceV2.js';
import '../../../icons/ListBullet.js';
import '../../../icons/BankIcon.js';
import '../../../icons/ClockOrangeV2.js';
import '../../../icons/CalendarOrangeV2.js';
import '../../../icons/ReferralIconV2.js';
import '../../../icons/MoneyIconV2.js';
import '../../../icons/UsersIconV3.js';
import '../../../icons/InfoFillV2.js';
import '../../../icons/LockOrange.js';
import '../../../icons/LockV2.js';
import '../../../icons/AlertOrange.js';
import '../../../icons/LiveSupportV2.js';
import '../../../icons/Chat.js';
import '../../../icons/CrossCircle.js';
import '../../../icons/LockV3.js';
import '../../../icons/CoinCrypto.js';
import { copyToBuffer } from '../../../../utils/copy-to-buffer.js';
import '../../../form/CheckBox/index.js';
import '../../../form/CodeInput/index.js';
import '../../../form/CryptoSelect/index.js';
import { FileUploader } from '../../../form/FileUploader/index.js';
import '../../../form/FormInput/index.js';
import '../../../form/FormSelect/index.js';
import '../../../form/PhoneInput/index.js';
import '../../../form/RadioButton/index.js';
import '../../../form/Select/index.js';
import '../../../form/SelectV2/index.js';
import '../../../form/SelectV3/index.js';
import '../../../form/SelectV4/index.js';
import '../../../form/Search/Input/index.js';
import '../../../form/Search/NoResults/index.js';
import '../../../form/Switch/index.js';
import '../../../form/DatePickerInput/index.js';
import styles from './index.module.scss.js';

const UserInfo = ({
  avatar,
  id,
  name,
  showRank,
  rank,
  rankLabel,
  configurable,
  canCopyId = true,
  canShareProfile = false,
  editable,
  bigIcon,
  onAdd = () => {
  },
  onEdit = () => {
  },
  onSubmit = () => {
  },
  onShare = () => {
  },
  onFileTypeError = () => {
  },
  className,
  style,
  type = "v1",
  text = {
    labelCopy: "Share profile"
  }
}) => {
  const [editedName, setEditedName] = useState(name);
  const ref = useRef(null);
  const refName = useRef(null);
  useEffect(() => {
    if (editable) {
      ref?.current?.focus();
    }
    if (!editable) {
      setEditedName(name);
      onEdit("");
    }
  }, [editable, name, ref]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, styles[type], className, "user-info"),
      style
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.avatar, {
          [styles["big-icon"]]: bigIcon,
          [styles["with-image"]]: !!avatar
        })
      },
      avatar ? /* @__PURE__ */ React.createElement("img", { src: avatar, alt: "avatar" }) : name.slice(0, 1),
      configurable && /* @__PURE__ */ React.createElement(
        FileUploader,
        {
          file: null,
          id: "user-upload-file",
          onTypeError: onFileTypeError,
          onChange: onAdd,
          simpleView: true
        }
      )
    )),
    /* @__PURE__ */ React.createElement("div", { className: styles.col }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.name, "user-info__name"),
        "data-active": editable,
        ref: refName
      },
      /* @__PURE__ */ React.createElement("span", null, name),
      editable && /* @__PURE__ */ React.createElement(
        "input",
        {
          ref,
          className: cx(styles.editable, "user-info__name"),
          type: "text",
          value: editedName,
          onKeyDown: (e) => {
            if (e.code === "Enter") {
              if (!editedName || editedName === name) return;
              onEdit(editedName);
              onSubmit(editedName);
            }
          },
          onChange: (e) => {
            setEditedName(e.target.value);
            onEdit(e.target.value);
          },
          style: {
            "--width": ref.current
          }
        }
      )
    ), !showRank && !canShareProfile && /* @__PURE__ */ React.createElement("div", { className: cx(styles.id, "user-info__id") }, "ID: ", id, canCopyId && /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        "aria-label": "copy button",
        className: styles["copy-button"],
        onClick: () => {
          copyToBuffer(id);
        }
      },
      /* @__PURE__ */ React.createElement(CopyIconFill, null)
    )), showRank && rank && /* @__PURE__ */ React.createElement(
      VipIcon,
      {
        levelText: rankLabel,
        level: rank,
        size: "sm",
        className: styles.rank__vip
      }
    ), showRank && !rank && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.rank,
        style: {
          "--color": rank ? "#FFFFFF99" : "#FFFFFF99"
        }
      },
      /* @__PURE__ */ React.createElement(RankIcon, null),
      rankLabel || rank || "Unranked"
    ), !showRank && canShareProfile && /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        "aria-label": "share button",
        className: styles["share-button"],
        onClick: () => {
          copyToBuffer(id);
          onShare(id);
        }
      },
      /* @__PURE__ */ React.createElement(CopyIconDouble, null),
      text.labelCopy
    ))
  );
};
UserInfo.displayName = "UserInfo";

export { UserInfo };
//# sourceMappingURL=index.js.map
